import type { isMobileResult } from 'ismobilejs';
import isMobile from 'ismobilejs';

export default () => (isMobile as unknown as isMobileResult).any;
